const permits = [
    {dashboard: true},
    {
        passengers: [
            {value: true, text: 'Todo'},
            {value: true, text: 'Gestión de pasajeros'},
            {value: true, text: 'Validación de pagos express'}
        ]
    },
    {
        drivers: [
            {value: true, text: 'Todo'},
            {value: true, text: 'Gestión de conductores'},
            {value: true, text: 'Orden de conductores'}
        ]
    },
    {managementBookings: true},
    {notification: true},
    {promotions: true},
    {
        reports: [
            {value: true, text: 'Todo'},
            {value: true, text: 'Historial de reservas'},
            {value: true, text: 'Listado rutas-conductores'},
            {value: true, text: 'Calificación de conductores'},
            {value: true, text: 'Resumen general de cobros y pagos'},
            {value: true, text: 'Estado de viajes programados'}
        ]
    },
    {
        initialSettings: [
            {value: true, text: 'Todo'},
            {value: true, text: 'Gestión de tipos de vehículos'},
            {value: true, text: 'Gestión de rutas y horarios'},
            {value: true, text: 'Restringir zonas'},
            {value: true, text: 'Razones de cancelación'},
        ]
    },
]

export {permits}
